import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock";

/**
 * @class Utils
 * @classdesc Several utility functions for use across the theme.
 */
class Utils {
  /**
   * Prevents all scrolling of the document
   *
   * @memberof Utils.prototype
   * @param {HTMLElement} element Element within which scrolling is allowed
   */
  scrollLock(element, allowScrollSelector, reserveScrollBarGap = true) {
    disableBodyScroll(element, {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el.getAttribute(allowScrollSelector) !== null) {
            return true;
          }

          el = el.parentElement;
        }
      },
      reserveScrollBarGap,
    });
  }

  /**
   * Removes the scroll lock from the page.
   *
   * @memberof Utils.prototype
   * @param {HTMLElement} element Element within which scrolling is allowed
   */
  scrollUnlock(element) {
    enableBodyScroll(element);
  }

  /**
   * Will return true/false if the scroll is locked on the page.
   *
   * @memberof Utils.prototype
   * @return {Boolean} True if scroll is locked on the page.
   */
  scrollIsLocked() {
    const html = document.querySelector('html');
    return html.classList.contains('scroll-locked');
  }

  /**
   * Helper function to block scroll on various events from the browser.
   *
   * @memberof Utils.prototype
   * @private
   */
  _blockScroll(event) {
    // Only block events that occur outside the modal
    if (event.target.closest('.allow-scroll-while-locked')) return;
    event.preventDefault();
    event.stopPropagation();
  }
}

export default new Utils();
